
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    base: process.env.BASE_URL,
    routes: [
        // {
        //   path: '/rewards',
        //   name: 'NsRewards',
        //   component: () => (import('./NsRewards/NsRewards.vue'))
        // },
        {
            path: '/landing',
            name: 'landing',
            component: () => (import('./views/Landing.vue'))
        },
        {
            path: '/',
            name: 'default',
            component: () => (import(/* webpackChunkName: "loyalty" */ './views/Dashboard.vue'))
        }
    ]
})
